import moment, { MomentInput } from 'moment/moment';

export const addOffset = (date: MomentInput, utcOffset: number) => {
    return moment(date).add(utcOffset, 'minutes');
};
